import React, { useMemo } from "react";

import { Box, Typography } from "@mui/material";
import globalColumns from "root/utils/columns/data";
import { tooltips } from "root/utils/tooltips";

import Tooltip_ from "root/components/Tooltip";
import TooltipIcon from "root/components/Tooltip/TooltipIcon";

// ----------------------------------------------------------------------------------------
const FilterFieldTitle = ({ dataIndex, title, tooltip: parentTooltip }) => {
  const tooltip = useMemo(() => {
    if (parentTooltip) return parentTooltip;
    const item = globalColumns[dataIndex] || {};
    return item.hint || item.tooltip || tooltips[dataIndex];
  }, [dataIndex]);

  return (
    <Box display="flex" alignItems="start" justifyContent="space-between" gap={1}>
      <Tooltip_ title={tooltip}>
        <Box display={"flex"} alignItems={"center"} gap={1} mb={1}>
          <Typography sx={tooltip && { cursor: "pointer" }} variant="subtitle2">
            {title}
          </Typography>
          {tooltip && <TooltipIcon />}
        </Box>
      </Tooltip_>
    </Box>
  );
};

export default FilterFieldTitle;
